import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, NgForm, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DropDownItem } from 'app/interfaces/items/dropDownItem';
import { ConfigsService } from 'app/services/api/configs/configs.service';
import { TranslationService } from 'app/services/api/translation/translation.service';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { DialogGeneral } from '../../../DialogGeneral';

export interface DialogConfigsAddData {
    data: Array<DropDownItem>;
}

@Component({
    selector: 'dialog-settings-configs-add',
    templateUrl: 'dialog-settings-configs-add.html',
    encapsulation: ViewEncapsulation.None,
})
export class DialogSettingsConfigsAdd extends DialogGeneral {
    @ViewChild('ngForm') ngForm: NgForm;
    form: UntypedFormGroup;
    formEnabled = true;

    /**
     * Constructor
     */
    constructor(
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<null>,
        public dialog: MatDialog,
        private configsService: ConfigsService,
        private alertsService: AlertsService,
        private translationService: TranslationService,
        @Inject(MAT_DIALOG_DATA) public data: DialogConfigsAddData
    ) {
        super(dialogRef);
        this.initForm();
    }

    initForm() {
        this.form = this._formBuilder.group({
            contextId: new UntypedFormControl('', [Validators.required]),
            key: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.pattern(/^[A-Z][a-zA-Z]*$/)]),
            value: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
        });
    }

    onChangeContext(contextId) {
        this.form.get('contextId').setValue(contextId);
    }

    addConfigs() {
        if (this.form.invalid) {
            this.alertsService.changealertHeader(this.translationService.translate('info_form_error'));
            this.alertsService.changeAlertErrorMessage(this.translationService.translate('info_form_fill_all_fields'));
            this.alertsService.changeAlertErrorShow(true);
            this.formEnabled = true;
            this.form.enable();
            return;
        }

        this.form.markAllAsTouched();
        this.formEnabled = false;
        this.form.disable();

        this.configsService
            .createConfigs({
                key: this.form.get('key').value,
                value: this.form.get('value').value,
                contextId: this.form.get('contextId').value,
            })
            .subscribe((success) => {
                if (success) {
                    this.dialogRef.close();
                } else {
                    this.formEnabled = true;
                    this.form.enable();
                }
            });
    }
}
